import React, { useEffect, useState, useContext, useRef, useCallback } from 'react'
import { DefaultContext } from '../../context/context_default';

import DeckDB from '../../database/wrappers/deck';
import { Search } from '@mui/icons-material';
export function useDeckCommunit() {

	const {
		getSubTipos,
		subTipos,
		tipos,
		getTipos,
		getPalavrasChave,
		palavraChave,
		getFortunas,
		getCausas,
		causas,
		fortunas,
		getRaridade,
		raridades,
		listCards,
		getListCards,
		is_descktop,
		filterFetch,
		setShowListCards,
		showListCards,
		showCardFlutuante,
		setShowCardFlutuante,
		listCardDeck,
		setListCardDeck,
		listCardDeckMatriz,
		setListCardDeckMatriz,
		quebradorDeck,
		setQuebradorDeck,
		globalFirestoreData,
		resetaDeck

	} = useContext(DefaultContext);

	const [listDecksUser, setListDecksUser] = useState([]);
	const [deckSelect, setDeckSelect] = useState(null)
	const [snapShot, setSnapShot] = useState(null)
	const [snapSize, setSnapSize] = useState(0)
	const [isOpenDeck, setIsOpenDeck] = useState(false)
	const [isOpenFilter, setIsOpenFilter] = useState(false);
	const [search, setSearch] = useState('')
	const [lastDoc, setLastDoc] = useState(null);
	const [hasMore, setHasMore] = useState(true);
	const [loading, setLoading] = useState(false);

	const lastDeckRef = useRef(null)
	const observer = useRef(null)

	const [debounceTimeout, setDebounceTimeout] = useState(null);
	const [filters, setFilters] = useState({
		orderBy: 'timestamp', // 'timestamp', 'likes'
		orderDirection: 'desc',
		causa: '',
		quebrador: ''
	});


	async function getDecks(field = null, operator = null, value = null, busca = null, isLoadMore = false) {
		if (loading) return;

		setLoading(true);
		const userDB = new DeckDB();

		try {
			if (!isLoadMore) {
				// Reset pagination for new search or initial load
				setListDecksUser([]);
				setLastDoc(null);
				setHasMore(true);
			}

			// Determina o campo de ordenação baseado nos filtros
			let orderByField = filters.orderBy;
			if (filters.orderBy === 'likes') {
				// Para ordenar por likes, vamos usar um campo calculado ou fazer ordenação no cliente
				orderByField = 'timestamp'; // Por enquanto, mantém timestamp e ordena no cliente
			}

			const { datas, lastDoc: lastDocument } = await userDB.getAllPaginated({
				field,
				operator,
				value,
				limit: 30,
				after: isLoadMore ? lastDoc : null,
				orderByField,
				orderDirection: filters.orderDirection
			});

			// Se ordenando por likes, faz ordenação no cliente
			let sortedDatas = datas;
			if (filters.orderBy === 'likes') {
				sortedDatas = datas.sort((a, b) => {
					const likesA = (a.likes || []).length;
					const likesB = (b.likes || []).length;
					return filters.orderDirection === 'desc' ? likesB - likesA : likesA - likesB;
				});
			}

			// Aplica filtros adicionais
			if (filters.causa) {
				sortedDatas = sortedDatas.filter(deck => {
					const deckCausa = getDeckCausa(deck);
					return deckCausa === filters.causa;
				});
			}

			if (filters.quebrador) {
				sortedDatas = sortedDatas.filter(deck => deck.quebrador === filters.quebrador);
			}

			if (isLoadMore) {
				setListDecksUser(prev => [...prev, ...sortedDatas]);
			} else {
				setListDecksUser(sortedDatas);
			}

			setLastDoc(lastDocument);
			setHasMore(datas?.length === 30);
		} catch (error) {
			console.error('Erro ao carregar decks:', error);
		} finally {
			setLoading(false);
		}
	}
	const handleSearch = useCallback(async () => {
		// Se o campo de busca estiver vazio, carrega todos os decks
		if (!search || search.trim() === '') {
			setSnapShot(null)
			setSnapSize(0)
			getDecks(null, null, null, false, false)
			return;
		}

		// Busca por nomes que contenham o termo de busca (case insensitive)
		setSnapShot(null)
		setSnapSize(0)

		// Carrega todos os decks e filtra no cliente para busca mais flexível
		const userDB = new DeckDB();
		try {
			const { datas } = await userDB.getAllPaginated({
				limit: 1000 // Carrega mais decks para busca local
			});

			// Filtra decks que contenham o termo de busca no nome (case insensitive)
			const searchTerm = search.toLowerCase().trim();
			const filteredDecks = datas.filter(deck =>
				deck.nome && deck.nome.toLowerCase().includes(searchTerm)
			);

			setListDecksUser(filteredDecks);
			setLastDoc(null);
			setHasMore(false); // Desabilita paginação durante busca
		} catch (error) {
			console.error('Erro na busca:', error);
		}
	}, [search]);

	const handleInputChange = useCallback((event) => {
		const newSearchTerm = event.target.value;
		setSearch(newSearchTerm);

		if (debounceTimeout) {
			clearTimeout(debounceTimeout);
		}

		const timeout = setTimeout(() => {
			// Executa a busca após o debounce
			if (newSearchTerm.trim() === '') {
				// Se campo vazio, recarrega todos os decks
				getDecks(null, null, null, false, false);
			} else {
				// Executa busca por nome
				handleSearch();
			}
		}, 500); // 500 milissegundos

		setDebounceTimeout(timeout);
	}, [debounceTimeout, handleSearch, getDecks]);


	// const steInfinito = async () => {
	//     setInfinit(infinit + 1)
	// }

	const NextPlan = async () => {
		if (hasMore && !loading) {
			getDecks(null, null, null, false, true);
		}
	}

	const loadMoreDecks = async () => {
		if (hasMore && !loading) {
			getDecks(null, null, null, false, true);
		}
	}

	const handleLike = async (deckId) => {
		if (!globalFirestoreData.userId) {
			alert('Você precisa estar logado para dar like!');
			return;
		}

		try {
			const userDB = new DeckDB();
			const result = await userDB.toggleLike(deckId, globalFirestoreData.userId);

			// Atualiza o deck na lista local
			setListDecksUser(prev => prev.map(deck => {
				if (deck.id === deckId) {
					const currentLikes = deck.likes || [];
					const updatedLikes = result.isLiked
						? [...currentLikes, globalFirestoreData.userId]
						: currentLikes.filter(id => id !== globalFirestoreData.userId);
					return { ...deck, likes: updatedLikes };
				}
				return deck;
			}));

			return result;
		} catch (error) {
			console.error('Erro ao dar like:', error);
			alert('Erro ao dar like. Tente novamente.');
		}
	}

	// Função para obter a causa do deck baseada no quebrador
	const getDeckCausa = useCallback((deck) => {
		if (!deck.quebrador || !listCards) return null;

		const quebradorCard = listCards.find(card => card.id === deck.quebrador);
		if (!quebradorCard || !quebradorCard.causa) return null;

		return quebradorCard.causa;
	}, [listCards]);

	// Função para obter lista de quebradores disponíveis
	const getQuebradores = useCallback(() => {
		if (!listCards) return [];

		// Filtra cartas que possuem o tipo 'TNRFPTd7eaKqQMBJWhpD' (tipo quebrador)
		const quebradores = listCards.filter(card => {
			return card.tipo && card.tipo.includes('TNRFPTd7eaKqQMBJWhpD');
		});

		return quebradores;
	}, [listCards]);

	// Função para verificar se uma carta é quebrador
	const isQuebrador = useCallback((cardId) => {
		if (!listCards || !cardId) return false;

		const card = listCards.find(c => c.id === cardId);
		return card && card.tipos && card.tipos.includes('TNRFPTd7eaKqQMBJWhpD');
	}, [listCards]);

	const applyFilters = (newFilters) => {
		const updatedFilters = { ...filters, ...newFilters };
		setFilters(updatedFilters);
	};

	const changeDeck = (deck) => {
		setDeckSelect(deck)
	}

	const toggleDrawerDeck = (valor) => {
		setIsOpenDeck(valor)
	}

	const toggleDrawerFilter = (valor) => {
		setIsOpenFilter(valor)
	}

	useEffect(() => {
		getDecks()
		resetaDeck()
	}, [])

	useEffect(() => {
		// Recarrega decks quando os filtros mudam
		if (filters.orderBy || filters.causa || filters.quebrador) {
			if (search && search.trim() !== '') {
				// Se há busca ativa, executa busca por nome
				handleSearch();
			} else {
				// Se não há busca, carrega decks com filtros
				getDecks();
			}
		}
	}, [filters, getDeckCausa, search, handleSearch])

	function searchChange(event) {
		setSearch(event.target.value);
	}


	const estiloCard = {
		top: showCardFlutuante ? `${window.innerHeight * 0.8 > showCardFlutuante?.y ? showCardFlutuante?.y : window.innerHeight * 0.8}px` : '0',

	};

	return {
		listDecksUser,
		deckSelect,
		setDeckSelect,
		changeDeck,
		isOpenDeck,
		toggleDrawerDeck,
		estiloCard,
		NextPlan,
		lastDeckRef,
		snapSize,
		handleInputChange,
		toggleDrawerFilter,
		isOpenFilter,
		loadMoreDecks,
		hasMore,
		loading,
		handleLike,
		filters,
		applyFilters,
		getQuebradores,
		isQuebrador
	}
}
